var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.orgComponent,_vm._b({tag:"component",class:['organization-name', {
        'organization-name--heavy': _vm.heavy,
    }]},'component',_vm.orgComponent === 'router-link' ? { to: _vm.link } : _vm.orgComponent === 'a' ? { href: _vm.link } : {},false),[_vm._v(" "+_vm._s(_vm.organization.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }